module.exports = __webpack_public_path__ + "img/weibo.9dc75458.jpg";